import { useState } from "react";
import type { OfficialReceipt } from "@ai-pos/shared";
import { receiptsApi } from "../api/resources.js";

interface Props {
  orderId: string;
  defaultDescription: string;
  onClose: () => void;
  onIssued: (result: { receipt: OfficialReceipt; printResult: { success: boolean; message: string } }) => void;
}

export function ReceiptIssueModal({ orderId, defaultDescription, onClose, onIssued }: Props) {
  const [recipientName, setRecipientName] = useState("");
  const [description, setDescription] = useState(defaultDescription);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleIssue = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const result = await receiptsApi.issue(orderId, { recipientName, description });
      onIssued(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : "領収書の発行に失敗しました");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal stack" onClick={(e) => e.stopPropagation()}>
        <h3>領収書発行</h3>
        <div className="form-field">
          <label htmlFor="receipt-recipient">宛名（空欄の場合は「上様」で印字されます）</label>
          <input
            id="receipt-recipient"
            value={recipientName}
            onChange={(e) => setRecipientName(e.target.value)}
            placeholder="上様"
          />
        </div>
        <div className="form-field">
          <label htmlFor="receipt-description">但し書き</label>
          <input id="receipt-description" value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="row">
          <button className="btn" onClick={onClose} disabled={submitting}>
            キャンセル
          </button>
          <button className="btn btn-primary" onClick={() => void handleIssue()} disabled={submitting}>
            {submitting ? "発行中..." : "発行して印刷"}
          </button>
        </div>
      </div>
    </div>
  );
}
